import { useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';

export const LoginPage = () => {
  const { error, errors } = useAuth();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = (e: any) => {
    e.preventDefault();
    setIsLoggingIn(true);

    // El endpoint OAuth2 puede no tener el prefijo /api
    const baseUrl =
      process.env.REACT_APP_API_URL?.replace('/api', '') ||
      'http://localhost:8090';
    window.location.assign(`${baseUrl}/oauth2/authorization/cognito`);
  };

  return (
    <>
      <div className="mainmenu-area">
        <div className="container text-left">
          <img
            id="imageLogoApp"
            alt="LogoContratistas"
            src={process.env.PUBLIC_URL + '/poncho-instalaciones.png'}
            className="logo-img"
          />
        </div>
      </div>

      <section
        className="login-area overlay center-block"
        id="login-page"
      >
        <div className="container" style={{ position: 'relative' }}>
          <div className="row">
            <div
              className="col-md-8"
              style={{ margin: '0 auto', display: 'block' }}
            >
              <div className="login-areabox">
                <div
                  className="row"
                  style={{ marginTop: '18px', marginBottom: '1px' }}
                >
                  <div className="col-sm-12 text-center">
                    <h4
                      style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '22px',
                        fontWeight: '600',
                        color: '#607d8b',
                      }}
                    >
                      Bienvenidos a PONCHO Contratistas
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <button
                      onClick={handleLogin}
                      className="btn btn-primary"
                      disabled={isLoggingIn}
                    >
                      {isLoggingIn
                        ? 'Iniciando sesión...'
                        : 'Acceder'}
                    </button>
                  </div>
                </div>
                {error
                  ? errors?.map((e: any, index: number) => (
                      <div key={index}>
                        <label
                          style={{
                            color: 'orangered',
                            fontSize: '14px',
                          }}
                        >
                          {e}
                        </label>
                      </div>
                    ))
                  : ''}
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer-area relative" id="contact-page">
        <div className="footer-middle">
          <div className="container">
            <div className="row">
              <div className="col-sm-4 text-right-log pt-4">
                <img
                  src={require('../../../resources/images/logo-poncho.png')}
                  alt=""
                  style={{ width: '215px' }}
                />
              </div>
              <div className="col-sm-6">
                <p
                  className="text-footer"
                  style={{ color: '#51565' }}
                >
                  Plataforma{' '}
                  <strong>COMPLIANCE LEGAL y CORPORATIVO</strong> en
                  materia de{' '}
                  <strong>
                    SEGURIDAD INDUSTRIAL, SEGURIDAD OPERATIVA y MEDIO
                    AMBIENTE
                  </strong>
                  , 100% configurable.
                </p>
                <p style={{ margin: '0px', padding: '0px' }}>
                  <a
                    href="https://poncho.grupomost.com/"
                    style={{ color: '#007cb3', fontSize: '12px' }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    poncho.grupomost.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 text-center">
                <p style={{ fontSize: '12px' }}>
                  &copy; Copyright 2020 GrupoMost
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
